import { InputLabel, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTheme } from 'styled-components';

interface Props {
  id: string;
  value?: string;
  label: string;
  placeholder: string;
  helperText?: string;
  password?: string;
  type?: string;
  endAdornment?: React.ReactNode;
  multiline?: boolean;
  rows?: number;
  testid?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Container = styled('div')(() => ({
  width: '100%',
  margin: '20px 0 0 0',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
}));

const StyledInputLabel = styled(InputLabel)(() => ({
  fontSize: 16,
  fontWeight: 500,
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '60%',
  fontFamily: theme.typography.fontFamily,
  padding: '0 !important',
  '& .MuiOutlinedInput-root': {
    minHeight: 40,
  },
  '& .MuiInputBase-input': {
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    background: 'white',
    padding: 12,
  },
  '& .MuiInputBase-multiline': {
    padding: 0,
  },
  '& .MuiInputAdornment-positionEnd': {
    background: 'white',
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    marginRight: 0,
    fontFamily: theme.typography.fontFamily,
  },
}));

const OutlinedTextField = (props: Props) => {
  const theme = useTheme();
  const labelColor = theme.isVaultVariant
    ? theme.newPalette.neutral.N800
    : theme.atlas.semantic.color.type.default;

  return (
    <Container>
      <StyledInputLabel htmlFor={props.id} sx={{ color: labelColor }}>
        {props.label}
      </StyledInputLabel>
      <StyledTextField
        data-testid={props.testid}
        id={props.id}
        placeholder={props.placeholder}
        variant="outlined"
        value={props.value}
        onChange={props.onChange}
        helperText={props.helperText}
        type={props.type}
        InputProps={{
          endAdornment: props.endAdornment,
        }}
        multiline={props.multiline}
        rows={props.rows}
      />
    </Container>
  );
};

export default OutlinedTextField;
